import { useState } from "react";
import dayjs from "dayjs";
import { useCategoriesListQuery } from "@/generated/graphql";
import { ProminentButtonStyled } from "@/shared";
import {
  CategoriesList,
  CategoryFormFactory,
  SubcategoryFormFactory,
} from "@/features/categories";
import { ActionsBar } from "@/components/layout";
import { useScope, scopeVariables } from "@/features/groups/scope-context";
import { useCategoriesActions } from "./use-categories-actions-hook";

export const CategoriesPageContainer = () => {
  const [createModalCategory, setCreateModalCategory] = useState(false);

  const scope = useScope();

  const {
    data: categoriesData,
    loading: loadingCategories,
    refetch: refetchCategories,
    // This page lists budgets rather than months, so it asks about the current
    // one. The figures are only shown on the expenses and home pages.
  } = useCategoriesListQuery({
    variables: {
      date: dayjs().format("MM-DD-YYYY"),
      ...scopeVariables(scope),
    },
  });

  const {
    openCategory,
    createModalSubcategory,
    updateModalCategory,
    updateModalSubcategory,
    anchorActionDropdownEl,
    setOpenCategory,
    setCreateModalSubcategory,
    setUpdateModalCategory,
    setUpdateModalSubcategory,
    handleEditCategory,
    handleEditSubcategory,
    handleRemoveCategory,
    handleRemoveSubcategory,
    handleActionsDropdownClick,
    handleActionsDropdownClose,
  } = useCategoriesActions(refetchCategories);

  const categories = categoriesData?.categories;

  return (
    <>
      <ActionsBar showScope>
        <ProminentButtonStyled
          small
          onClick={() => setCreateModalCategory(true)}
          data-testid="add-category-button"
        >
          Add category
        </ProminentButtonStyled>
      </ActionsBar>

      <CategoriesList
        loading={loadingCategories}
        categories={categories}
        openCategory={openCategory}
        createModalSubcategory={createModalSubcategory}
        updateModalCategory={updateModalCategory}
        updateModalSubcategory={updateModalSubcategory}
        anchorActionDropdownEl={anchorActionDropdownEl}
        onSetOpenCategory={setOpenCategory}
        onSetCreateModalSubcategory={setCreateModalSubcategory}
        onEditCategory={handleEditCategory}
        onEditSubcategory={handleEditSubcategory}
        onRemoveCategory={handleRemoveCategory}
        onRemoveSubcategory={handleRemoveSubcategory}
        onActionsDropdownClick={handleActionsDropdownClick}
        onActionsDropdownClose={handleActionsDropdownClose}
      />

      {createModalCategory && (
        <CategoryFormFactory
          open={createModalCategory}
          closeForm={() => {
            refetchCategories();
            setCreateModalCategory(false);
          }}
        />
      )}
      {createModalSubcategory && (
        <SubcategoryFormFactory
          open={Boolean(createModalSubcategory)}
          closeForm={() => {
            refetchCategories();
            setCreateModalSubcategory(null);
          }}
          presetCategoryId={createModalSubcategory}
          categories={categories!}
        />
      )}
      {updateModalCategory && (
        <CategoryFormFactory
          open={Boolean(updateModalCategory)}
          closeForm={() => {
            refetchCategories();
            setUpdateModalCategory(null);
          }}
          formData={updateModalCategory}
        />
      )}
      {updateModalSubcategory && (
        <SubcategoryFormFactory
          open={Boolean(updateModalSubcategory)}
          closeForm={() => {
            refetchCategories();
            setUpdateModalSubcategory(null);
          }}
          presetCategoryId={""}
          categories={categories!}
          formData={updateModalSubcategory}
          refetchCategories={refetchCategories}
        />
      )}
    </>
  );
};
